<template>
  <div class="patentList fatherHeight contBox" style="display: none;">
    <div id="piaoju" style="display: none;">
      <div class="hiprint-printTemplate" v-for="(pageItem,index1) in pageData" :key="index1">
        <div class="hiprint-printPanel panel-index-0" :id="'panelfee'+index1">
          <div class="hiprint-printPaper" original-height="140" style="width: 210mm; height: 147mm;">
            <div class="hiprint-printPaper-content">
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 380pt; height: 21pt; font-size: 18pt; font-weight: 600; letter-spacing: 2.5pt; color: rgb(41, 53, 227); text-align: center; line-height: 18pt; left: 113.5pt; top: 15pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">{{info.fee_title}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position:absolute;width: 100pt;height:15pt;color:rgb(41, 53, 227);text-align:left;line-height:13pt;left: 20pt;top: 45pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">姓名：{{info.psn_name}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position:absolute;width: 150pt;height:15pt;color:rgb(41, 53, 227);text-align:left;line-height:13pt;left:110pt;top: 45pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">就诊ID：{{info.mdtrt_id}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 180pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 255pt; top: 45pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">科室：{{info.dept_name}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 140pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 435pt; top: 45pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">票据号：{{info.bill_no}}</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-rect"
                style="border-color: rgb(0, 0, 0); border-image: initial; position: absolute; width: 572pt; height: 300pt; left: 10.5pt; top: 60pt;">
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width:100%; height: 30pt; color: rgb(0, 0, 0); left: 10pt; top: 60pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;padding: 7pt;">
                  <div style="display: flex;justify-content: start;align-items: center;flex-wrap: wrap;">
                     <span v-if="info.hl_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">护理费：{{info.hl_fee}}</span>
                     <span v-if="info.cl_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">材料费：{{info.cl_fee}}</span>
                     <span v-if="info.xy_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">西药费：{{info.xy_fee}}</span>
                     <span v-if="info.sy_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">检验-实验室：{{info.sy_fee}}</span>
                     <span v-if="info.tx_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">透析-血液透析：{{info.tx_fee}}</span>
                     <span v-if="info.lg_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">透析-血液透析滤过：{{info.lg_fee}}</span>
                     <span v-if="info.gl_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">透析-血液灌流：{{info.gl_fee}}</span>
                     <span v-if="info.zcy_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">中成药：{{info.zcy_fee}}</span>
                     <span v-if="info.ybzl_fee!=0" style="padding: 3pt 6pt;font-family: Microsoft YaHei !important;color: #000!important;">一般诊疗费：{{info.ybzl_fee}}</span>
                  </div>
                </div>
              </div>
             
             
            
             
              <div class="hiprint-printElement hiprint-printElement-hline"
                style="border-width: 0.75pt; border-color: rgb(41, 53, 227); position: absolute; width: 574pt; height: 10pt; left: 10pt; top: 100pt;">
              </div>
              <!-- 上面表格 -->
              <div class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 80pt; height: 10pt; color: rgb(41, 53, 227); left: 15pt; top: 110pt;">
                <table border="0"
                  style="text-align: center;width: 560pt; height: 10pt; color: rgb(41, 53, 227); font-size: 10pt;font-family: Microsoft YaHei !important;color: #000!important;">
                  <tr>
                    <td style="text-align: left;font-family: Microsoft YaHei !important;color: #000!important;">项目名称</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">规格</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">单位</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">单价</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">数量</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">金额</td>
                  </tr>
                  <tr v-for="(item,index) in pageItem" :key="index">
                    <td style="text-align: left;font-family: Microsoft YaHei !important;color: #000!important;padding-top: 5pt;">{{item.indexNum}}. {{item.drug}}</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">{{item.medi_spec}}</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">{{item.dict_first_unit_name}}</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">{{item.pric}}</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">{{item.cnt}}</td>
                    <td style="font-family: Microsoft YaHei !important;color: #000!important;">{{item.det_item_fee_sumamt}}</td>
                  </tr>
                </table>
              </div>
              <!-- 中间表格 -->
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 80pt;  color: rgb(41, 53, 227); left: 15pt; top: 370pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">共计(项)：{{info.fee_count}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 300pt;  color: rgb(41, 53, 227); left: 220pt; top: 370pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">大写金额：{{info.total_fee_zh}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 150pt;  color: rgb(41, 53, 227); left: 100pt; top: 370pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">总计(元)：{{info.totals}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 86pt;  color: rgb(41, 53, 227); left: 405pt; top: 370pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">收费员：{{info.opter}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 100pt;  color: rgb(41, 53, 227); left: 480pt; top: 370pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%;font-family: Microsoft YaHei !important;color: #000!important;">第{{index1+1}}页/共{{pageData.length}}页</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted ,defineExpose} from 'vue';
  import { chineseNumber } from '@/utils/tool'
   //A4的panel设置
   const a4Panel = { width: 210, height: 147, paperNumberDisabled: true, paperHeader: 5,  }
  import { autoConnect, disAutoConnect, hiprint, defaultElementTypeProvider } from 'vue-plugin-hiprint'
  const info = ref('')
  const pageData = ref([])
  const tableData = ref([])
  const page = 1
  const pageSize = 14
  const hiprintTemplate = ref({})
  onMounted(() => {
    
  })
  const initData = (item) => {
    tableData.value = []
    info.value = {}
    pageData.value = []
    info.value = item
    tableData.value = JSON.parse(JSON.stringify(info.value.drug_list))
    tableData.value.forEach((item,i)=>{
        item.indexNum = i+1
      })
    for (let i = 0; i < Math.ceil(tableData.value.length / pageSize); i++) {
      // pageData.value.push([])
      pageData.value[i] = tableData.value.slice(i * pageSize, (i + 1) * pageSize)
    }
  }
  hiprint.init()//初始化
  // disAutoConnect()// 取消自动连接直接打印客户端
  const print = () => {
    hiprintTemplate.value = {}
    let hiprintTemplate_ = new hiprint.PrintTemplate();
    hiprintTemplate.value = hiprintTemplate_
    pageData.value.forEach((item, index) => {
      console.log(2222,item)
      let panel = hiprintTemplate.value.addPrintPanel(a4Panel);
      panel.addPrintHtml({ options: { width: 210, height: 147, top: 8, left: 10, content: $('#panelfee' + index).html() } });
    })
    hiprintTemplate.value.print();
  }
  defineExpose({
    info,
    print,
    initData,
    hiprintTemplate
  })
</script>
<style scoped>
  .patentList {
    background-color: #fff;
    overflow: auto;
  }
</style>